import {
  AfterViewInit,
  Directive,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { ReplaySubject, firstValueFrom } from 'rxjs';
import { delay } from 'rxjs/operators';
import { OnLoaded } from '@lyceo/shared/dynamic-component-loading/feature-main';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[questionDisplayPlaceholder]',
})
export class QuestionDisplayPlaceholderDirective
  implements AfterViewInit, OnLoaded
{
  public viewContainerRef: ViewContainerRef = inject(ViewContainerRef);

  /**
   * Subject which starts to emit when the view is rendered. In this case it needed
   * because of the innerHtml of which the rendering takes place asynchronously of the
   * parents. With this we can tell the parent that the complete component in loaded.
   */
  public onFinishedInit$: ReplaySubject<void> = new ReplaySubject<void>();

  /**
   * @inheritDoc
   */
  public ngAfterViewInit(): void {
    this.onFinishedInit$.next();
    this.onFinishedInit$.complete();
  }

  /**
   * If the component has finished loading and is ready to use.
   */
  public ready(): Promise<void> {
    return firstValueFrom(this.onFinishedInit$.pipe(delay(20)));
  }
}
